import { render, staticRenderFns } from "./EnviarBase.vue?vue&type=template&id=1433f5d1"
import script from "./EnviarBase.vue?vue&type=script&setup=true&lang=js"
export * from "./EnviarBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports